export default __webpack_public_path__ + "static/media/027-taxi.78268d0d.svg";